export default (superClass) => {
    return class extends superClass {

        get interestType() {
            return this._data.interest_type;
        }

        get isFixedInterest() {
            return this.interestType === 'fixed';
        }

        get minInterestPossible() {
            if (this.isFixedInterest) {
                return this._data.interest_fixed;
            }

            return this._data.interest_interval_min;
        }

        get minInterestPossibleString() {
            return this.formatPercentage(this.minInterestPossible, 2);
        }

        get maxInterestPossible() {

            if (this.isFixedInterest) {
                return this._data.interest_fixed;
            }

            return this._data.interest_interval_max;
        }

        get maxInterestPossibleString() {
            return this.formatPercentage(this.maxInterestPossible, 2);
        }
    
        get interestString() {
            if(this.interestType == 'fixed') {
                return this.formatPercentage(this._data.interest_fixed, 2);
            }
    
            return this.formatPercentageRange(
                this._data.interest_interval_min, this._data.interest_interval_max, 2
            );
        }
    
        get effectiveInterestString() {
            if(this.interestType == 'fixed') {
                return this.formatPercentage(this._data.effective_interest_fixed, 2);
            }
    
            return this.formatPercentageRange(
                this._data.effective_interest_interval_min, this._data.effective_interest_interval_max, 2
            );
        }

        get minEffectiveInterestPossible() {
            if (this.isFixedInterest) {
                return this._data.effective_interest_fixed;
            }
            return this._data.effective_interest_interval_min; 
        }

        get minEffectiveInterestPossibleString() {
            return this.formatPercentage(this.minEffectiveInterestPossible, 2);
        }
        
        get maxEffectiveInterestPossible() {
            if (this.isFixedInterest) {
                return this._data.effective_interest_fixed;
            }
            return this._data.effective_interest_interval_max; 
        }

        get maxEffectiveInterestPossibleString() {
            return this.formatPercentage(this.maxEffectiveInterestPossible, 2);
        }
    }
}